import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const API_URL = process.env.REACT_APP_API_URL;

const EditCostModal = ({ product, isOpen, onClose, onSuccess }) => {
  const [costPrice, setCostPrice] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  const token = localStorage.getItem('token');
  const headers = useMemo(() => ({ Authorization: `Bearer ${token}` }), [token]);

  useEffect(() => {
    if (product) {
      setCostPrice(product.cost_price ? product.cost_price.toFixed(2) : '0.00');
      setMessage('');
    }
  }, [product]);

  const handleUpdateCost = async (e) => {
    e.preventDefault();
    if (!product || !costPrice) {
      setMessage('Please enter a valid cost price.');
      return;
    }

    setIsLoading(true);
    setMessage('');

    try {
      const res = await axios.put(
        `${API_URL}/products/${product.prodcode}/cost`,
        { cost_price: parseFloat(costPrice) },
        { headers }
      );

      toast.success(res.data.message || 'Cost updated successfully.');
      
      // Reset loading before closing
      setIsLoading(false);

      // Trigger parent refresh & close modal
      onSuccess();
      
    } catch (err) {
      toast.error(err.response?.data?.detail || 'An error occurred.');
      setIsLoading(false); // make sure button is reset on failure too
    }
  };

  if (!isOpen || !product) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Update Cost for: {product.prodname}</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleUpdateCost}>
            <div className="form-group">
              <label htmlFor="costPriceInput">
                New Cost Price (per {product.uom})
              </label>
              <input
                id="costPriceInput"
                type="text"
                inputMode="decimal"
                value={costPrice}
                onChange={(e) => setCostPrice(e.target.value)}
                autoFocus
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline"
                onClick={onClose}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isLoading}
              >
                {isLoading ? 'Updating...' : 'Update Cost'}
              </button>
            </div>
          </form>
          {message && <p className="modal-message">{message}</p>}
        </div>
      </div>
    </div>
  );
};

export default EditCostModal;
